import Features from "./sections/features";
import FrontPage from "./sections/frontPage";
import WorkDescription from "./sections/solution";
import Benefits from "./sections/benefits";
import Reviews from "./sections/references";
import Team from "./sections/team";
import ContactForm from "./sections/contact";
import Layout from "./components/layout";
import CookieConsent from "./components/CookieConsent";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <Layout>
          <FrontPage />
          <Features />
          <WorkDescription />
          <Benefits />
          <Reviews />
          <Team />
          <ContactForm />
        </Layout>
        <CookieConsent />
      </div>
    </QueryClientProvider>
  );
}

export default App;
